import { Breakpoints, BreakpointWrapper } from "@volkswagen-onehub/components-core";
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { FilterBar } from "../../FilterBar";
import { NewSearchButton } from "../../FilterBar/NewSearchButton";
import { Route } from "../../utils/use-route";
import ShareList from "../ShareList";
import SideCTAs from "./SideCTAs";
import { SortDropdown } from "./Sort";
import { Summary } from "./Summary";
import { ViewToggle } from "./View";

type BarContainerType = {
  spaceBetween?: boolean;
};

const TopBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--size-dynamic0050);
`;

const BarContainer = styled.div<BarContainerType>`
  margin: 0 var(--size-grid002);
  max-width: 1750px;
  display: flex;
  ${({ spaceBetween }) =>
    spaceBetween
    ? `
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;

    `
    : `
      flex-direction: column;
      align-items: flex-start;
      @media (min-width: ${Breakpoints.b960}px) {
        display: grid;
        grid-template-columns: auto auto 1fr;
        align-items: center;
      }
    `
  }

  column-gap: var(--size-dynamic0050);
  row-gap: 8px;
`;

export default () => {
  const location = useLocation();
  const params = useParams();

  return (
    <TopBarContainer>
      <BarContainer>
        {location.pathname !== '/' + Route.FAVOURTIES && !params.ulid ? (
          <>
            <div aria-live="polite">
              <Summary />
            </div>
            {/* ⏺ */}
            <NewSearchButton />
            <SideCTAs />
          </>
        ) : null}
      </BarContainer>
      <FilterBar />
      <BarContainer spaceBetween>
        <SortDropdown />

        { location.pathname == '/' + Route.FAVOURTIES && <ShareList /> }

        <BreakpointWrapper min={Breakpoints.b960}>
          <ViewToggle />
        </BreakpointWrapper>
      </BarContainer>
    </TopBarContainer>
  );
};
